import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Container, Row, Spinner } from 'react-bootstrap';


const Loader = () => 
    <Container>
        <Row className="justify-content-md-center">
            <Spinner animation="border" variant="primary" />
        </Row>
    </Container>;

ReactDOM.render(
        <Suspense fallback={<Loader />}>
            <App />
        </Suspense>
    , document.getElementById('root')
    );
serviceWorker.unregister();
